import React from 'react';
import '../styles/tokens.css';
import './Skeleton.css';

const Skeleton = ({ width, height, borderRadius, style, className, variant = 'pulse' }) => {
    const skeletonStyle = {
        width: width || '100%',
        height: height || '20px',
        borderRadius: borderRadius || '4px',
        ...style,
    };

    return (
        <div
            className={`skeleton skeleton-${variant} ${className || ''}`}
            style={skeletonStyle}
            aria-hidden="true"
            aria-busy="true"
            role="status"
        />
    );
};

export default Skeleton;
